var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import deviceOperatingHoursUpdate from '../../requests/devices/deviceOperatingHoursUpdate';
/**
 *
 */
var UpdateDeviceOperatingHoursCommand = /** @class */ (function (_super) {
    __extends(UpdateDeviceOperatingHoursCommand, _super);
    function UpdateDeviceOperatingHoursCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param deviceModel DeviceModel
     * @param newCumulativeOperatingHours number
     * @param organisationId string
     * @return {*}
     */
    UpdateDeviceOperatingHoursCommand.prototype.execute = function (deviceModel, newCumulativeOperatingHours, organisationId) {
        this.deviceModel = deviceModel;
        return deviceOperatingHoursUpdate(newCumulativeOperatingHours, organisationId, deviceModel.link_device_id);
    };
    return UpdateDeviceOperatingHoursCommand;
}(Command));
export default UpdateDeviceOperatingHoursCommand;
